import { customAlphabet, nanoid } from 'nanoid';
export const generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
export const generateNanoID = () => {
    return nanoid();
};
export const generateCustomNanoID = (alphabet, size = 21) => {
    const nanoId = customAlphabet(alphabet, size);
    return nanoId();
};
export const SPOTTER_ID_ALPHABET = '_-0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const SPOTTER_ID_SIZE = 12;
const _spotterNanoId = customAlphabet(SPOTTER_ID_ALPHABET, SPOTTER_ID_SIZE);
export const generateSpotterNanoID = () => _spotterNanoId();
export function encodeParams(params) {
    return Object.keys(params)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join('&');
}
export function comparator(value1, value2) {
    if (value1 && (value2 === undefined || value2 === null)) {
        return 1;
    }
    if (value2 && (value1 === undefined || value1 === null)) {
        return -1;
    }
    if (typeof value1 === 'string' && typeof value2 === 'string') {
        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();
    }
    return value1 === value2 ? 0 : value1 > value2 ? 1 : -1;
}
export function getRandomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
const allChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
export function getRandomAlphaNumericString(len) {
    let ret = '';
    for (let i = 0; i < len; i++) {
        const index = getRandomInteger(0, allChars.length - 1);
        ret += allChars[index];
    }
    return ret;
}
export function binArrayToJson(binArray) {
    let str = '';
    for (let i = 0; i < binArray.length; i++) {
        str += String.fromCharCode(parseInt(binArray[i]));
    }
    return JSON.parse(str);
}
const trendingTypeHrefMap = {
    PINBOARD_ANSWER_BOOK: 'pinboard',
    QUESTION_ANSWER_BOOK: 'saved-answer',
};
export const generateURL = (type, id) => {
    const route = `/${trendingTypeHrefMap[type]}`;
    const BASE = window.location.href.split('#')[0];
    return `${BASE}#${route}/${id}`;
};
const mapItemsData = (items, maxItemsPerType, itemDescriptionPrefix, itemAction) => {
    return items
        .slice(0, maxItemsPerType)
        .map(({ id, type, name, authorDisplayName, stats }) => {
        return {
            id,
            type,
            name,
            description: `${itemDescriptionPrefix} ${authorDisplayName}`,
            itemHref: generateURL(type, id),
            goToItem: itemAction,
            views: (stats === null || stats === void 0 ? void 0 : stats.views) || 0,
        };
    });
};
export function normalizeTrendingData(rawTrendingData, itemAction) {
    const trendingData = [];
    const data = rawTrendingData.data;
    if (!data) {
        return [];
    }
    if (data.pinboards && data.pinboards.length) {
        trendingData.push({
            items: mapItemsData(data.pinboards || [], rawTrendingData.maxTrendingItems, rawTrendingData.itemDescriptionPrefix, itemAction),
            title: rawTrendingData.title.pinboard,
            specificToSectionClass: rawTrendingData === null || rawTrendingData === void 0 ? void 0 : rawTrendingData.sectionClassNames.pinboard,
        });
    }
    if (data.answers && data.answers.length) {
        trendingData.push({
            items: mapItemsData(data.answers || [], rawTrendingData.maxTrendingItems, rawTrendingData.itemDescriptionPrefix, itemAction),
            title: rawTrendingData.title.answer,
            specificToSectionClass: rawTrendingData === null || rawTrendingData === void 0 ? void 0 : rawTrendingData.sectionClassNames.answer,
        });
    }
    return trendingData;
}
export const versionCompare = (left, right) => {
    if (typeof left + typeof right !== 'stringstring')
        return false;
    const a = left.split('.');
    const b = right.split('.');
    let i = 0;
    const len = Math.max(a.length, b.length);
    for (; i < len; i++) {
        if ((a[i] && !b[i] && parseInt(a[i], 10) > 0) ||
            parseInt(a[i], 10) > parseInt(b[i], 10)) {
            return 1;
        }
        if ((b[i] && !a[i] && parseInt(b[i], 10) > 0) ||
            parseInt(a[i], 10) < parseInt(b[i], 10)) {
            return -1;
        }
    }
    return 0;
};
export const getCircularReplacer = () => {
    const ancestors = [];
    return (key, value) => {
        if (typeof value !== 'object' || value === null) {
            return value;
        }
        while (ancestors.length > 0 && ancestors.at(-1) !== this) {
            ancestors.pop();
        }
        if (ancestors.includes(value)) {
            return '[Circular]';
        }
        ancestors.push(value);
        return value;
    };
};
//# sourceMappingURL=js-util.js.map